import React from 'react';
import TransactionsLink from 'components/Links/TransactionsLink';
import Dropdown from 'components/UIKit/Dropdown';

let translate = state => ({
  SUCCEEDED: 'Succeeded',
  FAILED: 'Failed',
  ERRORED: 'Errored',
  PENDING: 'In Progress',
}[state]);

let TransactionStateFilter = ({
  type,
  closed,
  committable,
  isDryRun,
  query,
  state,
  style,
}) => {
  return (
    <span style={style}>
      <span>State: &nbsp;</span>
      <Dropdown selected={committable ? 'To Be Committed' : closed ? 'Discarded' : translate(state) || 'All'}>
        <TransactionsLink
          query={{ ...query, ...(type || {}), ...(isDryRun || {}), offset: 0 }}
        >
          All
        </TransactionsLink>
        <TransactionsLink
          query={state === 'PENDING'
            ? query
            : { ...query, type, isDryRun, state: 'PENDING', offset: 0 }
          }
        >
          In Progress
        </TransactionsLink>
        <TransactionsLink
          query={committable === 'true'
            ? query
            : { ...query, type, isDryRun, committable: 'true', offset: 0 }
          }
        >
          To be committed
        </TransactionsLink>
        <TransactionsLink
          query={state === 'SUCCEEDED'
            ? query
            : { ...query, type, isDryRun, state: 'SUCCEEDED', offset: 0 }
          }
        >
          Succeeded
        </TransactionsLink>
        <TransactionsLink
          query={state === 'FAILED'
            ? query
            : { ...query, type, isDryRun, state: 'FAILED', offset: 0 }
          }
        >
          Failed
        </TransactionsLink>
        <TransactionsLink
          query={state === 'ERRORED'
            ? query
            : { ...query, type, isDryRun, state: 'ERRORED', offset: 0 }
          }
        >
          Errored
        </TransactionsLink>
        <TransactionsLink
          query={closed === 'true'
            ? query
            : { ...query, type, isDryRun, closed: true, offset: 0 }
          }
        >
          Discarded
        </TransactionsLink>
      </Dropdown>
    </span>
  );
};

export default TransactionStateFilter;
